import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=125fed36&scoped=true&"
import script from "./UsersTable.vue?vue&type=script&lang=js&"
export * from "./UsersTable.vue?vue&type=script&lang=js&"
import style0 from "./UsersTable.vue?vue&type=style&index=0&id=125fed36&prod&scoped=true&lang=scss&"
import style1 from "./UsersTable.vue?vue&type=style&index=1&id=125fed36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125fed36",
  null
  
)

export default component.exports